import { useTranslation } from 'react-i18next';
import ReportsDashboard from '../ReportsDashboard';

const AccessDashboard = () => {
  const { t } = useTranslation();
  return <ReportsDashboard type="access" pageTitle={`${t('dashboard')}: ${t('accesses')}`} />;
};

export default AccessDashboard;
